import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ServerService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  transitionAll(serverStateId: string): Observable<boolean> {
    return this.http.put<boolean>(`${this.appConfigService.getConfig().webApi}/api2/servers/ServerStates/${serverStateId}`, {})
      .pipe(catchError(this.errorHandler.handleError<boolean>(`[PUT] transition all servers failed`)));
  }

  toggleServer(serverId: string): Observable<boolean> {
    return this.http.put<boolean>(`${this.appConfigService.getConfig().webApi}/api2/servers/${serverId}`, {})
      .pipe(catchError(this.errorHandler.handleError<boolean>(`[PUT] toggle server failed`)));
  }
}
